import { all, call, put, select, takeLatest } from "redux-saga/effects";

import { controlInfinitiveScrollSelector } from "components/common/ListInfinitiveScrolling/redux/selector";
import { formFilterEmployeeLeaveSelector } from "../redux/selector";
import {
  getListEmployeeArriveLateRequestFailed,
  getListEmployeeArriveLateRequestStart,
  getListEmployeeArriveLateRequestSuccess,
} from "../redux/getListEmployeeArriveLateRequest";
import { getEmployeeArriveLateRequestApi } from "core/http/service/employeeRequest";
import { typeScrollEmployeeRequest } from "./exportEmployeeRequest";
import { declareLeaveURL } from "../Pages/Main/DeclareLeaveContent";

function* getListEmployeeArriveLateRequestWork() {
  const { offset, limit } = yield select(
    controlInfinitiveScrollSelector(
      typeScrollEmployeeRequest[declareLeaveURL.lackOfTime]
    )
  );
  const { from, to, ...rest } = yield select(formFilterEmployeeLeaveSelector);

  const params = {
    offset,
    limit,
    ...rest,
    fromMonth: from?.month() + 1,
    fromYear: from?.year(),
    toYear: to?.year(),
    toMonth: to?.month() + 1,
  };
  try {
    const res = yield call(getEmployeeArriveLateRequestApi, params);
    yield put({
      type: getListEmployeeArriveLateRequestSuccess.type,
      payload: {
        data: res.data,
        categoryName: res.categoryName,
        totalRecords: res.totalRecords,
      },
    });
  } catch (error: any) {
    yield put({
      type: getListEmployeeArriveLateRequestFailed.type,
    });
  }
}

function* watchGetListEmployeeArriveLateRequest() {
  yield takeLatest(
    getListEmployeeArriveLateRequestStart.type,
    getListEmployeeArriveLateRequestWork
  );
}

export default function* getListEmployeeArriveLateRequestSaga() {
  yield all([watchGetListEmployeeArriveLateRequest()]);
}
